import { EcommerceData } from "./AddToCart/addToCartHelpers";

type TriggerEvent = {
  event: string;
};

type CustomEvent = {
  event: string;
  eventLabel?: string;
  eventAction?: string;
  eventCategory?: string;
  eventName?: string;
};

type EcommerceEvent = {
  event: string;
  ecommerce: EcommerceData | Record<string, unknown>;
  firstTimePurchaser?: string;
};

type DataLayerVariable = {
  [key: string]: string | number | boolean | null;
};

type GtmEvent = TriggerEvent | CustomEvent | EcommerceEvent | DataLayerVariable;

const sendGtmEvent = (gtmEvent: GtmEvent) => {
  window.dataLayer.push(gtmEvent);
};

const clearEcommerceInDataLayer = () => {
  sendGtmEvent({ ecommerce: null });
};

const clearGa4EventInDataLayer = () => {
  sendGtmEvent({
    event: null,
    eventAction: null,
    eventName: null,
    eventCategory: null,
    eventLabel: null,
  });
};

const vendorDimension = "dimension39";

const itemNumberDimension = "dimension40";

const carouselIdDimension = "dimension52";

const productReviewCountDimension = "dimension64";

const analyticsStorageKey = "analyticsData";

export {
  GtmEvent,
  sendGtmEvent,
  vendorDimension,
  itemNumberDimension,
  carouselIdDimension,
  productReviewCountDimension,
  analyticsStorageKey,
  clearEcommerceInDataLayer,
  clearGa4EventInDataLayer,
};
